import { Button } from "@/components/core/buttons/button";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import caseEvidenceService from "@/features/case-evaluation/api/services/evidence-service";
import { downloadFile } from "@/utils/download-file";
import { IconAlertCircle } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import Alert from "../core/alert";

export default function CaseEvidenceListDowloadModal({
	caseId,
	evidenceType,
	parties,
	both,
}: { caseId: string; evidenceType: string; parties: string; both: boolean }) {
	const { closeModal } = useModalControl();
	const [isDownloading, setIsDownloading] = useState(false);
	const [isTestimonial, setIsTestimonial] = useState<boolean>(false);

	useEffect(() => {
		switch (evidenceType) {
			case "Documentary":
				setIsTestimonial(false);
				break;
			case "Testimonial":
				setIsTestimonial(true);
				break;
			case "Object":
				setIsTestimonial(false);
				break;
		}
	}, [evidenceType]);

	const handleDownload = async () => {
		setIsDownloading(true);

		if (!both && !isTestimonial) {
			// documentary and object, p or d
			const response = await caseEvidenceService.downloadListByType({
				case_id: caseId,
				parties: parties,
				evidence_type: evidenceType,
			});

			const url = URL.createObjectURL(response);

			downloadFile(url, `${parties}-${evidenceType}-Evidence.pdf`);
			setIsDownloading(false);
			closeModal();
		} else if (isTestimonial && !both) {
			// testimonial, p or d
			const response = await caseEvidenceService.downloadTestimonialEvidenceList({
				case_id: caseId,
				parties: parties,
			});

			const url = URL.createObjectURL(response);

			downloadFile(url, `${parties}-${evidenceType}-Evidence.pdf`);
			setIsDownloading(false);
			closeModal();
		} else if (both && !isTestimonial) {
			// documentary or object,both
			const response = await caseEvidenceService.downloadListByCaseId({
				case_id: caseId,
				evidence_type: evidenceType,
			});

			const url = URL.createObjectURL(response);

			downloadFile(url, `${parties}-${evidenceType}-Evidence.pdf`);
			setIsDownloading(false);
			closeModal();
		} else if (both && isTestimonial) {
			// testimonial,both
			const response = await caseEvidenceService.downloadAllTestimonialEvidenceByCaseId({
				case_id: caseId,
				evidence_type: evidenceType,
			});

			const url = URL.createObjectURL(response);

			downloadFile(url, `${parties}-${evidenceType}-Evidence.pdf`);
			setIsDownloading(false);
			closeModal();
		}
	};

	return (
		<>
			<div className="flex flex-col w-full col-span-12">
				<Alert type="info" allowClose={true} title="Remarks" className="mt-2" icon={<IconAlertCircle size={20} stroke={2} />}>
					This will generate {evidenceType} Evidence of {both ? "Both Plaintiff and Defendant" : parties}. The process may take a few moments depending on the
					size of the attachments.
				</Alert>
			</div>
			<div className="flex justify-end gap-2 mt-6">
				<Button variant="ghost" onClick={closeModal} className="px-4 py-2">
					Cancel
				</Button>
				<Button variant="default" loading={isDownloading} onClick={handleDownload} className="px-6 py-2">
					Confirm
				</Button>
			</div>
		</>
	);
}
